import { isArray, map, pick, result } from 'underscore';

export const partialConversionPairs = {
  // Old Property : New Property
  Conversions: 'ConversionsCredit',
  CPA: 'PartialConversionCPA',
  ConversionRate: 'PartialConversionRate',
  AllConversionCPA: 'AllPartialConversionCPA',
  AllConversions: 'AllConversionsCredit',
  AllConversionRate: 'AllPartialConversionRate',
  ViewThroughConversionsCPA: 'ViewThroughPartialConversionsCPA',
  ViewThroughConversionsRate: 'ViewThroughPartialConversionsRate',
  ViewThroughConversions: 'ViewThroughConversionsCredit',
  RepeatRate: 'PartialConversionRepeatRate',
};

// This function is only used to replace the name above
// Please do not use this function for anything else
// And do not extend this function
export function applyPartialConversionColumnName(permission = {}, names) {
  const {
    dynamic = {},
  } = permission;

  const {
    // This function is only used for Partial Conversions and Column Conversion
    PartialConversions: IsPartialConversionsEnabled,
    ColumnConversion: IsColumnConversionEnabled,
  } = dynamic;

  const usePartialConversions =
    IsPartialConversionsEnabled && IsColumnConversionEnabled;

  if (usePartialConversions) {
    if (isArray(names)) {
      return map(names, name =>
        result(partialConversionPairs, name, name));
    }
    return result(partialConversionPairs, names, names);
  }
  return names;
}

const ColumnConversionEnabledFeatures = {
  summary_tab_campaign: true,
  summary_tab_keyword: true,
  summary_tab_ad_group: true,
  summary_tab_ad: true,
  AdExtensionsGrid: true,
  DimensionsGrid: true,
  PerformanceGrid: true,
};

const perfMetricColumnConvertionDef = (sourceColumnName, targetColumnName) => ({
  sourceColumnName,
  sourceSortableProperty: `PerformanceMetrics/${sourceColumnName}`,
  targetSortableProperty: `PerformanceMetrics/${targetColumnName}`,
});
const perfMetricColumnConvertion = (sourceColumnName, targetColumnName) => ({
  [targetColumnName]: perfMetricColumnConvertionDef(sourceColumnName, targetColumnName),
});

function generateColumnConversionMetadataForColumns(columnNames) {
  return pick({
    ...perfMetricColumnConvertion('CPA', 'PartialConversionCPA'),
    ...perfMetricColumnConvertion('PartialConversionCPA', 'CPA'),
    ...perfMetricColumnConvertion('Conversions', 'ConversionsCredit'),
    ...perfMetricColumnConvertion('ConversionsCredit', 'Conversions'),
    ...perfMetricColumnConvertion('ConversionRate', 'PartialConversionRate'),
    ...perfMetricColumnConvertion('PartialConversionRate', 'ConversionRate'),
    ...perfMetricColumnConvertion('AllConversionCPA', 'AllPartialConversionCPA'),
    ...perfMetricColumnConvertion('AllPartialConversionCPA', 'AllConversionCPA'),
    ...perfMetricColumnConvertion('AllConversions', 'AllConversionsCredit'),
    ...perfMetricColumnConvertion('AllConversionsCredit', 'AllConversions'),
    ...perfMetricColumnConvertion('AllConversionRate', 'AllPartialConversionRate'),
    ...perfMetricColumnConvertion('AllPartialConversionRate', 'AllConversionRate'),
    ...perfMetricColumnConvertion('ViewThroughConversions', 'ViewThroughConversionsCredit'),
    ...perfMetricColumnConvertion('ViewThroughConversionsCredit', 'ViewThroughConversions'),
    ...perfMetricColumnConvertion('ViewThroughConversionsCPA', 'ViewThroughPartialConversionsCPA'),
    ...perfMetricColumnConvertion('ViewThroughPartialConversionsCPA', 'ViewThroughConversionsCPA'),
    ...perfMetricColumnConvertion('ViewThroughConversionsRate', 'ViewThroughPartialConversionsRate'),
    ...perfMetricColumnConvertion('ViewThroughPartialConversionsRate', 'ViewThroughConversionsRate'),
  }, columnNames);
}
function generateConversionColumns(permissions, featureName) {
  const {
    IsViewThroughConversionEnabled,
    IsViewThroughConversionsRevenueEnabled,
    dynamic = {},
  } = permissions;
  const {
    PartialConversions: IsPartialConversionsEnabled,
  } = dynamic;

  const usePartialConversions = IsPartialConversionsEnabled
    && ColumnConversionEnabledFeatures[featureName];

  const rawConversionColumns = [
    ...usePartialConversions ? [
      'PartialConversionCPA',
      'ConversionsCredit',
      'PartialConversionRate',
    ] : [
      'CPA',
      'Conversions',
      'ConversionRate',
    ],
    'AdvertiserReportedRevenue',
    'RevenueOnAdSpend',

    ...usePartialConversions ? [
      'AllPartialConversionCPA',
      'AllConversionsCredit',
      'AllPartialConversionRate',
    ] : [
      'AllConversionCPA',
      'AllConversions',
      'AllConversionRate',
    ],

    'AllConversionAdvertiserReportedRevenue',
    'AllConversionRevenueOnAdSpend',
  ];

  if (IsViewThroughConversionEnabled && usePartialConversions) {
    rawConversionColumns.push('ViewThroughConversionsCredit');
  } else if (IsViewThroughConversionEnabled && !usePartialConversions) {
    rawConversionColumns.push('ViewThroughConversions');
  }

  if (IsViewThroughConversionsRevenueEnabled && usePartialConversions) {
    rawConversionColumns.push('ViewThroughConversionsRevenue');
    rawConversionColumns.push('ViewThroughPartialConversionsCPA');
    rawConversionColumns.push('ViewThroughConversionsReturnOnAdSpend');
    rawConversionColumns.push('ViewThroughPartialConversionsRate');
  } else if (IsViewThroughConversionsRevenueEnabled && !usePartialConversions) {
    rawConversionColumns.push('ViewThroughConversionsRevenue');
    rawConversionColumns.push('ViewThroughConversionsCPA');
    rawConversionColumns.push('ViewThroughConversionsReturnOnAdSpend');
    rawConversionColumns.push('ViewThroughConversionsRate');
  }

  return rawConversionColumns;
}

export function getColumnsConversionMap(featureName, permissions) {
  const biColumnNames = [
    ...generateConversionColumns(permissions, featureName),
  ];
  const columnConversionMetadata = {
    ...generateColumnConversionMetadataForColumns(biColumnNames),
  };

  return columnConversionMetadata;
}
